import React from 'react'
import {Flex} from 'rebass'
import Slideshow from '../components/home/Slideshow'
import About from '../components/home/About'
import Services from '../components/home/Services'
import Values from '../components/home/Values'
import Contact from '../components/home/Contact';
import Partners from '../components/home/Partners';
import Articles from '../components/home/Articles';

const IndexPage = ({ data }) => (
    <Flex justifyContent='center'>
      <div>
      <Slideshow slideshowImage={data.slideshowImage} />
      <About />
      <Partners/>
      <Values />
      <Services />
      <Contact />
      <Articles articles={data.articles} />
    </div>
    </Flex>
)

export default IndexPage

export const query = graphql`
  query IndexQuery {
    slideshowImage: imageSharp(id: {regex: "/slide1/"}) {
      sizes(maxWidth: 850, quality: 90, traceSVG: { color: "#f3f3f3" }) {
        ...GatsbyImageSharpSizes
      }
    }
    articles: allMarkdownRemark(limit:3 sort: { fields: [frontmatter___dateTime], order: DESC } filter: { id: { regex: "/article/" } }) {
      totalCount
      edges {
        node {
          fields {
            slug
          }
          id
          frontmatter {
            title
            tagline
            author
            category
            dateTime(formatString: "DD/MM/YYYY")
            cover {
              childImageSharp {
                sizes(maxWidth: 1600, quality: 100, traceSVG: { color: "#f3f3f3" }) {
                  ...GatsbyImageSharpSizes_tracedSVG
                }
              }
            }
          }
          excerpt
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js